import React, { useState, useEffect } from "react";
import { Button, message, Select, Form, Input } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import http from "../../../../../services/http";

export const SugestoesColaboradores = ({ idSugestao }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const [colaboradores, setColaboradores] = useState([]);

	useEffect(() => {
		if (idSugestao > 0) {
			listarSugestoesColaboradores(idSugestao);
			listarColaboradores();
		}
	}, [idSugestao]);

	// LISTAR COLABORADORES
	const listarColaboradores = async () => {
		setLoading(true);
		const api = await http("get", `v1/usuario/lista_colaboradores`, []);
		if (api.statusCode === 200) {
			let array_colaboradores = [];
			if (api.response.data) {
				api.response.data.map((col) => {
					array_colaboradores.push({ value: col.id, label: `${col.matricula} - ${col.nome}` });
				});
			}
			setColaboradores(array_colaboradores);
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// LISTAR COLABORADORES ADICIONADOS
	const listarSugestoesColaboradores = async (id_sugestao) => {
		setLoading(true);
		const api = await http("get", `v1/sugestoes_colaboradores/listar/${id_sugestao}`, []);
		if (api.statusCode === 200) {
			let array_sug_colaboradores = [];
			if (api.response.data) {
				api.response.data.map((e) => {
					array_sug_colaboradores.push(e.id_colaborador);
				});
			}
			form.setFieldsValue({ colaboradores: array_sug_colaboradores });
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// ADICIONAR COLABORADORES
	const adicionarColaboradores = async (formulario) => {
		if (!formulario.id_sugestao) return;
		setLoading(true);
		const api = await http("post", `v1/sugestoes_colaboradores/adicionar`, formulario);
		if (api.statusCode === 200) {
			message.success("Alteração atualizada!");
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// ON SUBMIT
	const onSubmit = (formulario) => {
		formulario.id_sugestao = idSugestao;
		formulario.colaboradores = formulario.colaboradores.filter((value, index, self) => self.indexOf(value) === index);
		adicionarColaboradores(formulario);
	};

	return (
		<Form form={form} onFinish={onSubmit}>
			<Form.List name="colaboradores">
				{(fields, { add, remove }) => (
					<>
						{fields.map((field) => (
							<Form.Item required={false} key={field.key}>
								<Input.Group compact>
									<Form.Item {...field} noStyle>
										<Select
											showSearch
											placeholder="Selecione o colaborador"
											style={{ width: "80%" }}
											onChange={() => form.submit()}
											disabled={loading}
											options={colaboradores}
											filterOption={(input, option) =>
												(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
											}
										/>
									</Form.Item>
									{fields.length > 1 ? (
										<Button
											icon={<MinusCircleOutlined />}
											onClick={() => {
												remove(field.name);
												form.submit();
											}}
										/>
									) : null}
								</Input.Group>
							</Form.Item>
						))}
						<Form.Item>
							<Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
								Adicioanar campo
							</Button>
						</Form.Item>
					</>
				)}
			</Form.List>
		</Form>
	);
};
